import { defineNuxtPlugin } from '#app'; // Use #app alias for Nuxt imports

export default defineNuxtPlugin(async (nuxtApp) => {
   // Variables to hold the AOS library
   let AOS: any = null; // Use 'any' or install @types/aos for proper typing

   // Initialize AOS immediately on plugin load
   try {
      // Dynamically import the library and CSS
      const aosModule = await import('aos');
      AOS = aosModule.default || aosModule;
      await import('aos/dist/aos.css');

      // Initialize AOS immediately
      AOS.init({ once: true });
   } catch (error) {
      console.error('Failed to load or initialize AOS:', error);
   }

   // Use the 'page:finish' hook to refresh AOS after navigation
   nuxtApp.hook('page:finish', () => {
      if (AOS) {
         // Refresh AOS for new elements after navigation
         AOS.refreshHard();
      }
   });
});
